var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
export function genUniqueId(usedIds) {
    var id = new Date().getTime() + '';
    if (usedIds.indexOf(id) > -1) {
        return genUniqueId(usedIds);
    }
    else {
        return id;
    }
}
export var INTERVAL_REG_EXP = /^(0{0,1}[1-9]|1[0-2])\/[0-9]{4}$/;
function getCurrentOrLastYear(years) {
    var currentYear = new Date().getFullYear();
    if (years.length === 0 || years.includes(currentYear)) {
        return currentYear;
    }
    else {
        return years[years.length - 1];
    }
}
export function parseInterval(start, end, years) {
    var fallbackYear = getCurrentOrLastYear(years);
    var startFixed = start !== null && start !== undefined && INTERVAL_REG_EXP.test(start) ? start : "01/".concat(fallbackYear);
    var _a = __read(startFixed.split('/').map(function (p) { return Number.parseInt(p); }), 2), startMonth = _a[0], startYear = _a[1];
    var endFixed = end !== null && end !== undefined && INTERVAL_REG_EXP.test(end) ? end : "12/".concat(fallbackYear);
    var _b = __read(endFixed.split('/').map(function (p) { return Number.parseInt(p); }), 2), endMonth = _b[0], endYear = _b[1];
    return { startMonth: startMonth, startYear: startYear, endMonth: endMonth, endYear: endYear };
}
export function downloadFile(blob, fileName) {
    var a = document.createElement('a');
    document.body.appendChild(a);
    var file = window.URL.createObjectURL(blob);
    a.href = file;
    a.download = fileName;
    a.click();
    a.remove();
}
